export class SubstituirProduto{
    SafraId: number;
    ProdutoAntigoId: number;
    ProdutoNovoId: number;
    Dose: number = 0;
}
